module.exports = __webpack_public_path__ + "img/pending-requests-icon.32476171.svg";